"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGsoState = exports.readBigUInt64LE = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
const web3_js_1 = require("@solana/web3.js");
const BONK_MINT_MAINNET = 'DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263';
/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
function readBigUInt64LE(buffer, offset = 0) {
    const first = buffer[offset];
    const last = buffer[offset + 7];
    if (first === undefined || last === undefined) {
        throw new Error();
    }
    const lo = first
        + buffer[++offset] * Math.pow(2, 8)
        + buffer[++offset] * Math.pow(2, 16)
        + buffer[++offset] * Math.pow(2, 24);
    const hi = buffer[++offset]
        + buffer[++offset] * Math.pow(2, 8)
        + buffer[++offset] * Math.pow(2, 16)
        + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
}
exports.readBigUInt64LE = readBigUInt64LE;
// TODO: update parser to use non-deprecated buffer methods
function parseGsoState(buf) {
    const periodNum = Number(readBigUInt64LE(buf, 8));
    const subscriptionPeriodEnd = Number(readBigUInt64LE(buf, 16));
    const lockupRatioTokensPerMillion = Number(readBigUInt64LE(buf, 24));
    const gsoStateBump = Number(buf.readUInt8(32));
    const soAuthorityBump = Number(buf.readUInt8(33));
    const xBaseMintBump = Number(buf.readUInt8(34));
    const baseVaultBump = Number(buf.readUInt8(35));
    const strike = Number(readBigUInt64LE(buf, 36));
    const soNameLengthBytes = Number(buf.readUInt8(44));
    const projectName = String.fromCharCode.apply(String, 
    // @ts-ignore
    buf.slice(48, 48 + soNameLengthBytes));
    const soStateOffset = 48 + soNameLengthBytes;
    const stakingOptionsState = new web3_js_1.PublicKey(buf.slice(soStateOffset, soStateOffset + 32));
    const authority = new web3_js_1.PublicKey(buf.slice(soStateOffset + 32, soStateOffset + 32 + 32));
    let baseMint = new web3_js_1.PublicKey(buf.slice(soStateOffset + 64, soStateOffset + 64 + 32));
    if (baseMint.toBase58() === '11111111111111111111111111111111') {
        // Backwards compatibility hack.
        baseMint = new web3_js_1.PublicKey(BONK_MINT_MAINNET);
    }
    let lockupPeriodEnd = Number(readBigUInt64LE(buf.slice(soStateOffset + 96, soStateOffset + 96 + 32)));
    if (lockupPeriodEnd === 0) {
        // Backwards compatibility hack for subscription period
        lockupPeriodEnd = subscriptionPeriodEnd;
    }
    return {
        periodNum,
        subscriptionPeriodEnd,
        lockupRatioTokensPerMillion,
        gsoStateBump,
        soAuthorityBump,
        xBaseMintBump,
        baseVaultBump,
        strike,
        soNameLengthBytes,
        projectName,
        stakingOptionsState,
        authority,
        baseMint,
        lockupPeriodEnd,
    };
}
exports.parseGsoState = parseGsoState;
